module.exports = __webpack_public_path__ + "img/s1-13.ad743a45.jpeg";